export enum UserLevel {
  SITE = 1,
  CER = 2,
  ADMIN = 3,
  INTRAPRESA = 4,
}
